export default "__VITE_ASSET__DEKr3AO1__"